import { InfiniteData } from '@tanstack/react-query'

import { ListRequestReturnType } from '@/api/models/notifications/lib/notifications.types'

const notificationHelpersByAll = {
  updateInfiniteReadStatus(
    oldData:
      | InfiniteData<{ page: number; response: ListRequestReturnType }>
      | undefined
  ) {
    if (!oldData) {
      return oldData
    }

    const newData = oldData?.pages?.map(page => ({
      ...page,
      response: {
        ...page.response,
        data: {
          ...page.response.data,
          data:
            page.response.data.data?.map(item => ({
              ...item,
              is_readed: true
            })) || []
        }
      }
    }))

    return {
      ...oldData,
      pages: newData
    }
  },

  updateFirstPageReadStatus(old: ListRequestReturnType | undefined) {
    if (!old) {
      return old
    }

    return {
      ...old,
      data: {
        ...old.data,
        data: old.data.data?.map(item => ({ ...item, is_readed: true })) || []
      }
    }
  }
}

export { notificationHelpersByAll }
